import SmallBarcodeSVG from "images/SmallBarcode.svg"
import { fresponsive } from "library/fullyResponsive"
import styled, { css } from "styled-components"
import colors from "styles/colors"
import textStyles from "styles/text"

type KickerProps = {
	children: React.ReactNode
	className?: string
	barcodes: "double" | "left" | "right" | "none"
	variant: "short" | "long"
}

export default function Kicker({
	children,
	className,
	barcodes,
	variant,
}: KickerProps) {
	return (
		<Wrapper className={className} $variant={variant}>
			{(barcodes === "double" || barcodes === "left") && <SmallBarcode />}
			{children}
			{(barcodes === "double" || barcodes === "right") && <SmallBarcode />}
		</Wrapper>
	)
}

const Wrapper = styled.div<{ $variant: "short" | "long" }>`
	${(props) =>
		fresponsive(css`
			color: ${props.$variant === "short" ? colors.grey3 : colors.slate};
			gap: ${props.$variant === "short" ? "10px" : "16px"};
			${textStyles.kicker2};
			align-items: center;
			display: flex;
		`)}
`

const SmallBarcode = styled.img.attrs({ src: SmallBarcodeSVG, alt: "" })`
	${fresponsive(css`
		height: 18px;
	`)}
`
